// import classnames from "classnames";
import { observer } from "mobx-react-lite";
import { Box, Divider, Flex, Spacer } from "@chakra-ui/react";
import "../../Header/index.scss";
// import { genBlock } from "@/utils/bem";
import { themeStore } from "@/stores/theme";
import { LeftPanelType, uiStore, updateUI } from "@/stores/ui";
import { ReactComponent as TabTxt2Img } from "@/assets/icons/tab_text2img.svg";
import { ReactComponent as TabImg2Img } from "@/assets/icons/tab_img2img.svg";
import { ReactComponent as TabPresets } from "@/assets/icons/tab_preset_cat.svg";
import { ReactComponent as TabAdjust } from "@/assets/icons/tab_adjust.svg";
import { ReactComponent as TabEraser } from "@/assets/icons/tab_eraser.svg";
import { ReactComponent as TabCut } from "@/assets/icons/tab_img_cut.svg";
import { ReactComponent as TabImgExpand } from "@/assets/icons/tab_img_expand.svg";
import { ReactComponent as TabParams } from "@/assets/icons/tab_params2img.svg";
import { ReactComponent as TabReplace } from "@/assets/icons/tab_replace.svg";
import { ReactComponent as TabHd } from "@/assets/icons/tab_resolution_hd.svg";
import { ReactComponent as TabVariation } from "@/assets/icons/tab_variation.svg";
import { ReactComponent as TabSettings } from "@/assets/icons/tab_settings.svg";
import { ReactComponent as TabNegativePrompt } from "@/assets/icons/tab_negative_prompt.svg";
import { ReactComponent as TabOutpainting } from "@/assets/icons/tab_img_expand.svg";
import IconButton from "@/components/IconButton";
import { SvgIcon } from "@/components/Icon";
import { Editor_Words } from "@/utils/lang/editor";
import { langStore, translate } from "@noli/business";
import { useScrollBar } from "@/hooks/useScrollbar";
import React from "react";

type IconConfig = {
  name: LeftPanelType;
  icon: SvgIcon;
  mt?: string;
  fillAll?: boolean;
  strokeByCurrentColor?: boolean;
  text: string;
  style?: React.CSSProperties;
};

type DividerConfig = {
  name: "divider";
  style?: React.CSSProperties;
};

type NavConfigType = Array<IconConfig | DividerConfig>;

function LeftNavigation() {
  const { iconColor } = themeStore.styles;
  const leftPanel = uiStore.leftPanel;
  const lang = langStore.tgt;
  const size = "45px";
  const sizeH = "45px";
  // const headerBlock = genBlock("c-nav");
  // const getClassName = (element: string, focused: boolean): string => {
  //   const modifier = focused ? "enabled" : undefined;
  //   if (isUndefined(modifier)) return headerBlock({ e: element });
  //   return classnames(headerBlock({ e: element }), headerBlock({ m: `${element}_${modifier}` }));
  // };

  const handleClick = (type: LeftPanelType) => updateUI("leftPanel", type);
  const navConfig: NavConfigType = [
    {
      name: "txt2imgPresets",
      icon: TabPresets,
      text: Editor_Words["left-nav-presets"],
      mt: "24px",
    },
    {
      name: "divider",
    },
    {
      name: "txt2img",
      icon: TabTxt2Img,
      mt: "0px",
      text: Editor_Words["left-nav-txt2img"],
    },
    {
      name: "txt2imgVariation",
      icon: TabVariation,
      text: Editor_Words["left-nav-variation"],
    },
    {
      name: "img2img",
      icon: TabImg2Img,
      text: Editor_Words["left-nav-img2img"],
    },
    {
      name: "imageProcess",
      icon: TabHd,
      text: Editor_Words["left-nav-hd"],
    },
    {
      name: "text2img-inpainting",
      icon: TabReplace,
      text: Editor_Words["left-nav-inpaint"],
    },
    {
      name: "inpainting",
      icon: TabEraser,
      text: Editor_Words["left-nav-eraser"],
    },
    {
      name: "negativePrompt",
      icon: TabNegativePrompt,
      text: Editor_Words["left-nav-negative-prompt"],
    },
    {
      name: "outpainting",
      icon: TabOutpainting,
      text: Editor_Words["left-nav-outpaint"],
    },
    {
      name: "matt",
      icon: TabCut,
      text: Editor_Words["left-nav-matting"],
    },
    {
      name: "divider",
    },
    {
      name: "params2img",
      icon: TabParams,
      text: Editor_Words["left-nav-param"],
      mt: "0px",
    },
  ];

  const { scrollBarProps } = useScrollBar();

  return (
    <Flex w="100%" h="100%" color={iconColor} direction="column" alignItems="center">
      <Flex direction="column" {...scrollBarProps} w="100%" align="center">
        {navConfig.map((nav, index) =>
          nav.name === "divider" ? (
            <Divider key={index} w="70%" my="12px" />
          ) : (
            <IconButton
              icon={nav.icon}
              p="2px"
              bg={leftPanel === nav.name ? "#4D4D4D" : "transparent"}
              w={"auto"}
              h={"auto"}
              mt={nav.mt ?? "10px"}
              rounded="6px"
              fillAll={nav.fillAll ?? true}
              strokeByCurrentColor={nav.strokeByCurrentColor}
              onClick={() => handleClick(nav.name)}
              key={nav.name}
              color={leftPanel === nav.name ? "#36c19e" : "#b3b3b3"}
              text={translate(nav.text, lang)}
              style={nav.style}
              textProps={{ maxW: "58px", textAlign: "center" }}
            />
          ),
        )}
      </Flex>
      <Spacer />

      <IconButton
        icon={TabSettings}
        w={size}
        h={sizeH}
        py="8px"
        mt="16px"
        mb="40px"
        rounded="6px"
        onClick={() => handleClick("settings")}
        strokeByCurrentColor
        bg={leftPanel === "settings" ? "#4D4D4D" : "transparent"}
        color={leftPanel === "settings" ? "#36c19e" : "#b3b3b3"}
      />
    </Flex>
  );
}

export default observer(LeftNavigation);
